import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import type { CreateChatTarget, ExtractedUtmParameters } from '@percent/cause-dashboard/services/aichat/aichat'
import { UTM_PARAM_KEYS } from '@percent/cause-dashboard/services/aichat/aichat'
import { Button, Spinner, Typography } from '@percent/lemonade'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import styles from './AIGateway.module.scss'

export const AIGateway = () => {
  const { aiChat } = useServices()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const [grantsUrlForManualRedirect, setGrantsUrlForManualRedirect] = useState<string | null>(null)

  const handleManualRedirect = (redirectUrl: string) => {
    window.open(redirectUrl, '_self')
  }

  const handleRedirectToAiChat = useCallback(async () => {
    const target = searchParams.get('target')
    const utmParams: ExtractedUtmParameters = {}

    UTM_PARAM_KEYS.forEach(key => {
      const value = searchParams.get(key)
      if (value) {
        utmParams[key] = value
      }
    })

    setTimeout(async () => {
      const response = await aiChat.createChat({ target: target as CreateChatTarget, ...utmParams })
      const redirectUrl = response.data.redirectUrl

      const newWindow = window.open(redirectUrl, '_self')

      if (!newWindow) {
        setGrantsUrlForManualRedirect(redirectUrl)
      }
    }, 1000)
  }, [aiChat, searchParams])

  useEffect(() => {
    handleRedirectToAiChat()
  }, [handleRedirectToAiChat])

  return (
    <div className={styles.container}>
      <div className={styles.loadingContent}>
        <Spinner size="l" />
        <Typography variant="h3">{t('typography.aiGateway.title')}</Typography>
        <p className={styles.message}>{t('typography.aiGateway.message')}</p>
        {grantsUrlForManualRedirect && (
          <Button
            variant="primary"
            data-testid="manual-redirect-button"
            onClick={() => handleManualRedirect(grantsUrlForManualRedirect)}
          >
            {t('typography.aiGateway.manualRedirectButton')}
          </Button>
        )}
      </div>
    </div>
  )
}
